import { render } from "./OrderDetail.vue?vue&type=template&id=723dcb30"
import script from "./OrderDetail.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./OrderDetail.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script